import React from 'react';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import HomeIcon from '@mui/icons-material/Home';
import LogoutIcon from '@mui/icons-material/Logout';

const AccessDenied = () => {
  const goToLogin = () => {
    window.sessionStorage.clear();
    window.sessionStorage.setItem("loggedIn", false);
    window.location.href = '/login';
  };

  const goToHome = () => {
    window.location.href = '/home';
  };

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '75vh',
      padding: '1.5rem'
    }}>
      <div 
        className="glass-panel" 
        style={{
          padding: '2.75rem 2.25rem',
          textAlign: 'center',
          maxWidth: '500px',
          width: '100%',
          borderRadius: '24px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '1.25rem',
          boxShadow: '0 20px 40px -15px rgba(215, 25, 32, 0.08), 0 0 0 1px rgba(215, 25, 32, 0.06)'
        }}
      >
        <div style={{
          width: '64px',
          height: '64px',
          borderRadius: '50%',
          backgroundColor: '#fee4e2',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#d92d20'
        }}>
          <LockOutlinedIcon style={{ fontSize: '32px' }} />
        </div>

        <div>
          <h2 style={{
            fontSize: '1.4rem',
            fontWeight: 700,
            color: '#101828',
            marginBottom: '0.5rem'
          }}>
            Acceso Restringido
          </h2>
          <p style={{
            color: '#667085',
            fontSize: '0.92rem',
            lineHeight: 1.55,
            margin: 0
          }}>
            No cuentas con los privilegios suficientes para visualizar este módulo o tus credenciales requieren verificación. Contacta al administrador si requieres autorización.
          </p>
        </div>

        <div style={{
          display: 'flex',
          gap: '0.75rem',
          flexWrap: 'wrap',
          justifyContent: 'center',
          marginTop: '0.5rem',
          width: '100%'
        }}>
          <button
            type="button"
            className="btn-mobilia-primary"
            onClick={goToHome}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '0.5rem',
              flex: '1 1 180px',
              height: '42px',
              fontSize: '0.88rem'
            }}
          >
            <HomeIcon style={{ fontSize: '1.1rem' }} />
            <span>Ir al Inicio</span>
          </button>

          <button
            type="button"
            className="btn-mobilia-secondary"
            onClick={goToLogin}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '0.5rem',
              flex: '1 1 180px',
              height: '42px',
              fontSize: '0.88rem'
            }}
          >
            <LogoutIcon style={{ fontSize: '1.1rem', color: '#667085' }} />
            <span>Cerrar Sesión</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default AccessDenied;
